// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"46b705c21aba39906c59","691":"1eb8585f6ea8d531f6ca"}[chunkId] + ".js";
};